import { gql } from '@apollo/client';

import { ASSET2_FRAGMENT } from '../../../../AdForm/hooks/fragments/asset2Fragment';

export const SEARCH_ASSETS_2 = gql`
  query SearchAssets2($name: String, $type: String!, $countryCode: String, $limit: Int, $offset: Int) {
    searchAssets2(name: $name, type: $type, countryCode: $countryCode, limit: $limit, offset: $offset) {
      edges {
        node {
          ...asset2Fragment
        }
      }
    }
  }
  ${ASSET2_FRAGMENT}
`;
